// extracted by mini-css-extract-plugin
export default {"select":"AddStructure_select__FHTyr","label":"AddStructure_label__LZ5Se"};